<template>
  <div class="forwarding-receipt">
    <page-header title="Электронная экспедиторская расписка" />
    <div id="advantages" class="public-container public-container-mobile">
      <forwarding-receipt-main />
      <public-info-grid
        :title="content.blocks?.advantages.title"
        class="forwarding-receipt-advantages my-110"
        :items="items"
      />
      <public-block-stages
        id="stages"
        :title="content.blocks?.stages.title"
        :items="stages"
      />
      <forwarding-receipt-additional />
    </div>
  </div>
</template>

<script setup lang="ts">
import PageHeader from '~/components/public/page-header.vue'
import PublicInfoGrid from '~~/components/public/public-info-grid.vue'
import PublicBlockStages from '~/components/public/public-block-stages.vue'
import ForwardingReceiptMain from '~/components/public/forwarding-receipt/forwarding-receipt-main.vue'
import ForwardingReceiptAdditional from '~/components/public/forwarding-receipt/forwarding-receipt-additional.vue'
import {getPageContent} from '~/api/content';

const content = await getPageContent('/forwarding-receipt')

const items = computed(() => [
  {
    icon: {
      url: '/svg/vz-rocket.svg'
    },
    title: content.blocks?.advantages.fastTitle,
    text: content.blocks?.advantages.fastText,
  },
  {
    icon: {
      url: '/svg/vz-armchair.svg'
    },
    title: content.blocks?.advantages.easyTitle,
    text: content.blocks?.advantages.easyText,
  },
  {
    icon: {
      url: '/svg/vz-gear.svg'
    },
    title: content.blocks?.advantages.practicalTitle,
    text: content.blocks?.advantages.practicalText,
  }
])

const stages = computed(() => [
  {
    icon: {
      url: '/svg/vz-box.svg'
    },
    text: content.blocks?.stages.item_1
  },
  {
    icon: {
      url: '/svg/vz-people.svg'
    },
    text: content.blocks?.stages.item_2
  },
  {
    icon: {
      url: '/svg/vz-record.svg'
    },
    text: content.blocks?.stages.item_3
  },
  {
    icon: {
      url: '/svg/vz-success-thin.svg'
    },
    text: content.blocks?.stages.item_4
  },
  {
    icon: {
      url: '/svg/vz-mobile-phone.svg'
    },
    text: content.blocks?.stages.item_5
  },
  {
    icon: {
      url: '/svg/vz-pdf.svg'
    },
    text: content.blocks?.stages.item_6
  }
])
</script>
